import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var IonBottomSheetProvider = /** @class */ (function () {
    function IonBottomSheetProvider() {
    }
    IonBottomSheetProvider.prototype.ibsProvider = function () {
        return 'The Ionic Bootom Sheet Component';
    };
IonBottomSheetProvider.ɵfac = function IonBottomSheetProvider_Factory(t) { return new (t || IonBottomSheetProvider)(); };
IonBottomSheetProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IonBottomSheetProvider, factory: function (t) { return IonBottomSheetProvider.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IonBottomSheetProvider, [{
        type: Injectable
    }], function () { return []; }, null); })();
    return IonBottomSheetProvider;
}());
export { IonBottomSheetProvider };

//# sourceMappingURL=ion-bottom-sheet-provider.js.map